import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/Footer";

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

return (
    <Stack sx={{
        minHeight: "100vh",
        flexDirection: "column",
      }}>
      <Stack sx={{flex:1}}>
        <Outlet />
      </Stack>
      <Footer />
    </Stack>
  );
}
